export default __webpack_public_path__ + "static/media/Logo_Trust_WAS@3x.16d6398e.png";